import dayjs from 'libs/dayjs'

export const convertNumberToDateTime = (time?: number) => {
  if (!time) return null
  return dayjs(Number(time) * 1000)
}

export const convertDateTimeToNumber = (time?: dayjs.Dayjs) => {
  if (!time) return null
  return time.unix()
}
